import { AbstractControl, ValidationErrors } from '@angular/forms';
import { parseMoneyInput } from './money';

export function requiredPositiveCurrency(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || raw === '') return { required: true };
  const num = parseCurrencyAmount(raw);
  return Number.isFinite(num) && num > 0 ? null : { required: true };
}

export function requiredNonZeroCurrency(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || raw === '') return { required: true };
  const num = parseCurrencyAmount(raw);
  return Number.isFinite(num) && num !== 0 ? null : { required: true };
}

export function requiredNegativeCurrency(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || raw === '') return { required: true };
  const num = parseCurrencyAmount(raw);
  return Number.isFinite(num) && num < 0 ? null : { required: true };
}

export function rejectAllCurrency(_control: AbstractControl): ValidationErrors {
  return { unknownSignConstraint: true };
}

export function parseCurrencyAmount(raw: unknown): number {
  if (typeof raw === 'number') return raw;
  if (typeof raw === 'string') return parseFloat(raw.replace(/,/g, ''));
  return NaN;
}

export function maxTwoDecimalPlaces(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || raw === '') return null;
  const num = parseCurrencyAmount(raw);
  if (!Number.isFinite(num)) return null;
  return Number(num.toFixed(2)) === num ? null : { maxTwoDecimalPlaces: true };
}

export function currencyAmount(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw === null || raw === undefined || raw === '') return null;
  return parseMoneyInput(raw) === null ? { currencyAmount: true } : null;
}
